__turbopack_context__.v({
  "container": "TextInputField-module-scss-module__ATh1JW__container",
  "inputField": "TextInputField-module-scss-module__ATh1JW__inputField",
});
